import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "inputUse", "value", "onBlur"];
import FilterOperatorErrorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorErrorType';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UINumberInput from 'UIComponents/input/UINumberInput';
import I18n from 'I18n';
import { getTransferableProps } from './filterInputProps';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FilterOperatorPercentageInput extends Component {
  constructor(...args) {
    super(...args);
    this.handleRenderedValueChange = ({
      target: {
        value
      }
    }) => {
      const {
        onChange
      } = this.props;
      onChange(syntheticEvent(value / 100));
    };
  }
  render() {
    const _this$props = this.props,
      {
        error,
        inputUse,
        value,
        onBlur
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const isError = error.get('error');
    const errorMessage = error.get('message');
    const renderedValue = value ? value * 100 : value;
    const transferableProps = getTransferableProps(rest);
    const {
      ['data-selenium-test']: dataSeleniumTest,
      placeholder
    } = transferableProps;
    // @ts-expect-error allows us to avoid spreading props to UIComponents
    const disabled = transferableProps.disabled;
    // @ts-expect-error allows us to avoid spreading props to UIComponents
    const readOnly = transferableProps.readOnly;
    return /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
        position: "end",
        text: "%",
        children: /*#__PURE__*/_jsx(UINumberInput, {
          "data-selenium-test": dataSeleniumTest,
          placeholder: placeholder,
          disabled: disabled,
          readOnly: readOnly,
          onBlur: onBlur,
          onChange: this.handleRenderedValueChange,
          use: inputUse,
          value: renderedValue
        })
      })
    });
  }
}
FilterOperatorPercentageInput.propTypes = {
  error: FilterOperatorErrorType.isRequired,
  inputUse: PropTypes.oneOf(['on-dark']),
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number
};